<template>
    <!-- Footer Start  -->
    <div class="section footer-section ">

        <!-- Footer Copyright Start -->
        <div class="footer-copyright temp-fix-footer">
            <div class="container">

                <!-- Footer Copyright Start -->
                <div class="copyright-wrapper">
                    <div class="copyright-text footer-align-center">
                        <p>&copy; 2025 <span> COLREGs </span> Made with <i class="icofont-heart-alt"></i> by <a
                                href="#">Flying Colors Consultancy</a></p>
                    </div>
                </div>
                <!-- Footer Copyright End -->

            </div>
        </div>
        <!-- Footer Copyright End -->

    </div>
    <!-- Footer End -->

    <!--Back To Start-->
    <a href="#" class="back-to-top">
        <i class="icofont-simple-up"></i>

    </a>
    <!--Back To End-->
</template>

<script>

export default {
    name: 'DashboardFooter'
};
</script>